import { render, staticRenderFns } from "./AreaInvestigacionPage.vue?vue&type=template&id=7f77f076"
import script from "./AreaInvestigacionPage.js?vue&type=script&lang=js&external"
export * from "./AreaInvestigacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports